import { schemas } from 'constants/schemas';
import type { Field } from 'models/field';
import type { Section } from 'models/section';
import { normalizeResponse } from 'utils/normalize/normalize';

export const normalizeAcademicFields = (
  fields: Field[] = [],
): {
  entities?: {
    fields: Record<string, Field>;
    sections: Record<string, Section>;
  };
  result?: string[];
} => {
  return fields.length
    ? normalizeResponse<{
        fields: Record<string, Field>;
        sections: Record<string, Section>;
      }>(fields, schemas.academic)
    : {};
};
